const style = {
  container: {
    border: `1px solid #666`
  },
  inputWrapper: {
    ':not(:first-of-type)': {
      borderLeft: `1px solid #666`
    }
  },
  input: {
    background: `white`,
    color: `#666`
  },
  select: {
    background: `#fff`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Revenue/Main/style/ColorBlind/form.js